const AwinTracking = () => {
    // Get the current URL's search parameters
    const urlParams = new URLSearchParams(window.location.search);
    const awcParam = urlParams.get('awc');

    // If 'awc' parameter exists, set the '_awin_awc' cookie
    if (awcParam) {
      // Set cookie to expire in 30 days
      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 30);
      
      // Format the cookie string with expiration and path
      document.cookie = `_awin_awc=${awcParam}; expires=${expirationDate.toUTCString()}; path=/; Secure;`;
    }
}

export default AwinTracking;
